import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  class: "card-header border-0 pt-6",
  style: {"position":"sticky","top":"45px","background-color":"white","z-index":"1"}
}
const _hoisted_3 = { class: "card-title flex-column flex-md-row align-items-stretch align-items-md-center gap-2" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_7 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-end align-items-center d-none",
  "data-kt-customer-table-toolbar": "selected"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder me-5" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "me-2",
      "data-kt-customer-table-select": "selected_count"
    }),
    /*#__PURE__*/_createTextVNode("Selected ")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-danger",
    "data-kt-customer-table-select": "delete_selected"
  }, " Delete Selected ")
], -1)
const _hoisted_14 = { style: {"width":"100%","margin-left":"5px"} }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table table-striped gy-5 gs-10" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold fs-4 text-gray-800 border-bottom-2 border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-400px" }, "Ürünler"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Fiyatı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Yeni Fiyat"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px" }, "Değişim")
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_19 = ["onUpdate:modelValue", "onChange", "onClick", "disabled", "title"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" / ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PriceSettingsDropdown = _resolveComponent("PriceSettingsDropdown")!
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-solid w-250px ps-14",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterparams) = $event)),
            placeholder: "Ürün Filtrele"
          }, null, 512), [
            [_vModelText, _ctx.filterparams]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _createVNode(_component_Multiselect, {
            class: "ps-14",
            modelValue: _ctx.selectedCategory,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCategory) = $event)),
            options: _ctx.categories,
            mode: "tags",
            searchable: true,
            locale: "tr",
            style: {"max-width":"300px"}
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.List = _ctx.PropList))
          }, " Tüm Ürünler "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCloseProducts()))
          }, " Kapalı Ürünler "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getOpenProducts()))
          }, " Açık Ürünler "),
          _createElementVNode("button", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
            ])
          ]),
          _createVNode(_component_PriceSettingsDropdown, {
            Settings: _ctx.settingsPC,
            onUpdated: _ctx.priceSettingsUpdated
          }, null, 8, ["Settings", "onUpdated"]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary me-3",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.savePrice())),
            disabled: _ctx.isSaving
          }, " Kaydet ", 8, _hoisted_12)
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.filtervaluem?.length ?? 0) + " Ürün bulundu ", 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("table", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.filtervaluem as ProductNGDTO[]), (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, [
                (!item.HideImage)
                  ? (_openBlock(), _createBlock(_component_el_avatar, {
                      key: 0,
                      shape: "square",
                      size: 50,
                      fit: "contain",
                      src: _ctx.ProductNGDTO.imageUrl(item),
                      onError: ($event: any) => (item.HideImage = true)
                    }, null, 8, ["src", "onError"]))
                  : _createCommentVNode("", true),
                (item.HideImage)
                  ? (_openBlock(), _createBlock(_component_el_avatar, {
                      key: 1,
                      shape: "square",
                      size: 50,
                      class: "bg-primary fs-2 fw-bold text-inverse-primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ProductNGDTO.firstLetter(item)), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ]),
              _createElementVNode("td", {
                style: _normalizeStyle(_ctx.ProductNGDTO.priceEqual(item) ? 'color: black' : 'color: red'
                )
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.integrationProducts, (iproduct, ix) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: ix }, [
                    _createTextVNode(_toDisplayString(iproduct.product?.Price) + " ", 1),
                    (item.integrationProducts &&
                    ix < item.integrationProducts.length - 1
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_18
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 4),
              _createElementVNode("td", {
                style: _normalizeStyle(_ctx.ProductNGDTO.priceEqual(item) ? 'color: black' : 'color: red')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.integrationProducts, (iproduct, ix) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: ix }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      step: "0.50",
                      "onUpdate:modelValue": ($event: any) => ((iproduct.product.NewPrice) = $event),
                      onChange: ($event: any) => (_ctx.updatePrices(iproduct.product.NewPrice, item)),
                      onClick: ($event: any) => (_ctx.updateToHighPrice(iproduct.product, item)),
                      disabled: iproduct.product?.NewPrice == null,
                      class: "form-control price-input",
                      title: _ctx.IntegrationProduct.friendlyName(iproduct),
                      style: _normalizeStyle('background-color: ' +
                      _ctx.IntegrationProduct.statusColor(
                        iproduct,
                        iproduct.product.Status
                      ) + '; border: 2px solid ' + _ctx.IntegrationProduct.platformColor(iproduct))
                    }, null, 44, _hoisted_19), [
                      [_vModelText, iproduct.product.NewPrice]
                    ]),
                    (item.integrationProducts && ix < item.integrationProducts.length - 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 4),
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.integrationProducts, (iproduct, ix) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: ix }, [
                    _createTextVNode(" % " + _toDisplayString(((iproduct.product?.NewPrice / iproduct.product?.Price) * 100 - 100).toFixed(0)) + " ", 1),
                    (item.integrationProducts &&
                    ix < item.integrationProducts.length - 1
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_20
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}